var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#606060"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.16 23.88L37.8267 26.1866L21.6533 16.8533L22.9867 14.5466L27.04 16.88L28.8533 16.3866L34.6267 19.72L35.12 21.5466L39.16 23.88ZM20 37.3333V21.3333H26.76L36 26.6666V37.3333C36 38.0405 35.719 38.7188 35.219 39.2189C34.7189 39.719 34.0406 40 33.3333 40H22.6667C21.9594 40 21.2811 39.719 20.781 39.2189C20.281 38.7188 20 38.0405 20 37.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOpen);
export default __webpack_public_path__ + "static/media/deleteOpen.0752f4bb4f1403ee0e5d2de6e0763155.svg";
export { ForwardRef as ReactComponent };